import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { UiModule } from '../ui';
import { SharedUiModule } from '../../shared/ui';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { RecordService } from './record.service';
import { RecordResolver } from './record.resolver';
import { RecordListComponent } from './record-list.component';
import { RecordEditComponent } from './record-edit.component';
import { RecordFilterDialogComponent } from './record-filter-dialog.component';
import { RecordSearchDialogComponent } from './record-search-dialog.component';

@NgModule({
  imports: [
    BrowserModule,
    SharedUiModule,
    UiModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    RouterModule
  ],
  declarations: [
    RecordListComponent,
    RecordEditComponent,
    RecordFilterDialogComponent,
    RecordSearchDialogComponent
  ],
  providers: [
    RecordService,
    RecordResolver
  ],
  bootstrap: [
    RecordFilterDialogComponent,
    RecordSearchDialogComponent,
  ]
})
export class RecordModule { }
